import { ActionTypes } from '../constants'
import Cookies from 'js-cookie'
import URI from 'urijs'
import Event from '@app/models/event'
import Api, { apiAction } from '../api'

export const changeLocale = (locale, subdomain = undefined) => dispatch => {
  I18n.locale = locale

  const uri = URI(window.location.href)
  const subdomain = subdomain || uri.subdomain()
  const domain = uri.subdomain(subdomain).normalize().domain()

  try { window.setZendeskLocale(locale) }
  catch(e) { console.error(e); }

  Cookies.set('locale', locale, {
    domain: domain,
    expires: 365 * 20
  })

  dispatch({
    type: ActionTypes.CHANGE_LOCALE,
    locale: locale
  })
}

function stateRequest() {
  return {
    type: ActionTypes.STATE_REQUEST
  }
}

function stateFetchingSuccess(response) {
  return {
    type: ActionTypes.STATE_FETCHING_SUCCESS,
    event: new Event(response.data)
  }
}

function stateFetchingFailure(error) {
  return {
    type: ActionTypes.STATE_FETCHING_FAILURE,
    error: error
  }
}

export function fetchState() {
  return apiAction({
    requestor: () => Api.states.index(),
    onBeforeSend: stateRequest,
    onSuccess: stateFetchingSuccess,
    onFailure: stateFetchingFailure
  })
}
